
      import BringForward from './bring-forward.vue'
      import type { App, Plugin } from 'vue'

      export const BringForwardPlugin: Plugin = {
        install(app: App) {
          app.component('BringForward', BringForward)
        },
      }
      export { BringForward }
      